module.exports = __webpack_public_path__ + "static/media/wom-mas-400-gigas.42daf479.svg";